window.LightSignupForm = function(scope, code, hUser, state, redirectLink, localize, clientId) {
    var self = this;
    var formName = "light-signup-form";
    self.name = formName;

    var _protected = BaseForm.call(self, formName, scope);

    var lightSignUpModal = $("#light-sign-up");

    const initRecaptcha = () => {
        self.loadRecaptcha = true;

        hRecaptchaUtil.initRecaptchaScript()
            .then(() => {
                self.loadRecaptcha = false;
                scope.$digest();
            })
            .catch((err) => {
                console.error(err)
            });
    };

    self.load = function() {
        if (code) {
            initRecaptcha();

            LightSignUpAPI.GetUserInfo(code)
                .then(function (res){
                    self.data = res.data;
                    self.data.document_types = self.data.document_types || [];

                    lightSignUpModal.modal()
                        .on('hidden.bs.modal', function (e) {
                            Utils.redirectToWorkspace("registration.login", {brand: clientId});
                        });

                    scope.$digest();
                }, function (err){
                    if (err.data?.data === "ALREADY_SIGNUP") {
                        var title = $filter("translate")("Already Registered");
                        var message = $filter("translate")("You've already signed up with this email, Please login to continue.");
                        hAlert(title, message, function (e) {
                            Utils.redirectToWorkspace("registration.login", {brand: clientId});
                        });
                    } else {
                        var title = $filter("translate")("Wrong Link");
                        var message = $filter("translate")("Please refer to the link you've received on your email.");
                        hAlert(title, message, function (e) {
                            Utils.redirectToWorkspace("registration.login", {brand: clientId});
                        });
                    }

                });
        }
        else {
            Utils.redirectToWorkspace("registration.login", {brand: clientId});
        }
    };

    self.save = function() {

        if  (self.validator.validate()) {
            self.data.user_info.code = code;

         hRecaptchaUtil.execute(`light_register`)
            .then(function (gRecaptchaResponse) {

                self.loading = true;

                LightSignUpAPI.UpdateUserInfo(self.data.user_info, gRecaptchaResponse)
                    .then(function (res){
                        if (redirectLink) {
                            hRedirect(redirectLink);
                        } else {
                            state.go("registration.login", {brand: clientId});
                        }
                    }, function (err){

                        var message = (err && err.data && err.data.data) || $filter("translate")("Something went wrong!");
                        self.loading = false;

                        scope.$digest();
                        hAlert("Error", message, function (e) {
                            Utils.redirectToWorkspace("registration.login", {brand: clientId});
                        });
                    });
                scope.$digest();
            })
        }
    };

    self.load();

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
            case "password-email-match":
                if(value && (value === self.data.user_info.email)){
                    if (showError) {
                        self.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;

            case "weak-password":
                if(value && !Utils.validatePassword(value).pass && Utils.validatePassword(value).strength === 'weak') {
                    if (showError) {
                        self.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;

            case "short-password":
                if(value && !Utils.validatePassword(value).pass && Utils.validatePassword(value).strength === 'short') {
                    if (showError) {
                        self.validator.validation[name].errors[rule.name] = true;
                    }
                    return false;
                }
                break;
        }
        return true;
    };
};
